import React  from "react";
import { useParams } from 'react-router-dom';
import FarmParcelForm from "./components/FarmParcelForm";

const EditFarmParcel = () => {
	const { farmerinformationId, farmparcelId } = useParams();

	return (
	    <div>
	      <div className="mt-5 grid h-full grid-cols-1 gap-4">
			<FarmParcelForm farmerId={farmerinformationId} recordId={farmparcelId} mode="edit"/>
	      </div>
	    </div>
    );
};

export default EditFarmParcel;